import React, {Fragment} from "react";
import SFXButtonComponent from "./SFXButtonComponent";
import {Input, Row} from "reactstrap";
import BankAccountService from "../services/Registration/BankAccountService";
import ToastHelper from "../utils/ToastHelper";
import ViewHeaderComponent from "./ViewHeaderComponent";
import {decimalValidator, stringValidator} from "../domain/RequiredFieldTypes";

export default class IssueBankCardComponent extends React.Component {
    constructor(props) {
        super(props);

        this.schema = {};

        this.state = {
            barcode: "",
            cardFee: "",

            validFields: {},
            inValidFields: {}
        };

        this.schema = {
            cardFee: decimalValidator("cardFee", "Card Fee", true),
            barcode: stringValidator("barcode", "Barcode", true,6,6)
        };

        this.validateInputFields = this.validateInputFields.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.renderInput = this.renderInput.bind(this);
        this.renderErrorMessage = this.renderErrorMessage.bind(this);
    }

    validateInputFields(field) {

        let self = this;
        let previousInvalidValidations = {...this.state.inValidFields};
        delete previousInvalidValidations[field];
        let previousValidValidations = {...this.state.validFields};
        previousValidValidations[field] = true;

        this.setState({
            inValidFields: previousInvalidValidations,
            validFields: previousValidValidations
        }, () => {

            let fieldValue = this.state[field];

            if (this.schema[field] !== undefined) {
                this.schema[field].validate({[field]: fieldValue}).catch(function (err) {

                    let previousInvalidValidations = {...self.state.inValidFields};
                    previousInvalidValidations[field] = err.message;
                    let previousValidValidations = {...self.state.validFields};
                    delete previousValidValidations[field];

                    self.setState({
                        inValidFields: previousInvalidValidations,
                        validFields: previousValidValidations
                    });
                })
            }
        });
    }

    isFormValid() {
        return (this.state.validFields["barcode"] && this.state.validFields["cardFee"]);
    }

    handleChange = (event, field) => {
        this.setState({
            [field]: event.target.value
        });

        this.validateInputFields(field);
    };

    issueBankCard() {
        BankAccountService.linkBankCardToBankAccount(this.state.barcode, this.props.registrationId, this.state.cardFee).then(response => {
            if (response.accountStatus) {
                ToastHelper.success("Bank Card Issued Successfully.");
                if (this.props.btnCancelClick) {
                    this.props.btnCancelClick();
                }
            } else {
                ToastHelper.formatError(response);
            }
        });
    }

    render() {
        let className = this.props.isMobile ? "mobile" : "browser";

        return <Fragment>

            <ViewHeaderComponent>Issue Bank Card</ViewHeaderComponent>
            {this.renderInput(className, "Barcode", "barcode")}
            {this.renderInput(className, "Card Fee", "cardFee")}

            <hr/>
            <SFXButtonComponent onClick={this.props.btnCancelClick}>
                Cancel
            </SFXButtonComponent>
            {'   '}

            <SFXButtonComponent onClick={this.issueBankCard.bind(this)}
                                className={"btn btn-primary"}
                                disabled={!this.isFormValid()}
            >
                Issue Card
            </SFXButtonComponent>

        </Fragment>
    }

    renderInput(className, text, field) {

        return <Row className={className + "_input_row_register"}>
            <div className={className + "_input_div_register"}>
                <Input value={this.state[field]} placeholder={text}
                       id={field}
                       onChange={(event) => this.handleChange(event, field)}
                />
                {this.state.inValidFields[field] && this.renderErrorMessage(field, this.state.inValidFields[field])}
            </div>
        </Row>
    }

    renderErrorMessage(field, message) {
        return <h6>
            {message}
        </h6>;
    }

}
